export default class ArticleFlag {
  constructor(articleId, categories, round_categories) {
    this.articleId = articleId;
    this.categories = categories;
    this.round_categories = round_categories;
  }
}
